import React from 'react';
import { Box } from '@mui/material';
import { useStickyBox } from 'react-sticky-box';

import './styles.scss';

interface Props {
  children: React.ReactNode;
}

const StickyHeader = ({ children }: Props) => {
  const stickyRef = useStickyBox();
  return (
    <Box
      sx={{
        backgroundColor: 'background.default', pb: 2, zIndex: 99,
      }}
      className="stickeyHeaderWrap"
      ref={stickyRef}
      component="div"
    >
      {children}
    </Box>
  );
};

export default StickyHeader;
